import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { key: 1 }

import { computed, ref, onMounted, markRaw } from 'vue';
import { useRoute } from 'vue-router';
import Fuse from 'fuse.js';

import { showError } from '@services/utils/dialog';

import NcTextField from '@nextcloud/vue/components/NcTextField';

import ClusterGrid from '@components/ClusterGrid.vue';

import { t } from '@services/l10n';
import * as dav from '@services/dav';
import * as utils from '@services/utils/common';

import type { ICluster, IFace } from '@typings';

import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FaceList',
},
  __name: 'FaceList',
  props: {
    plus: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const route = useRoute();

const list = ref<IFace[] | null>(null);
const fuse = ref<Fuse<IFace> | null>(null);
const search = ref(String());

const user = computed(() => route.params.user?.toString());
const name = computed(() => route.params.name?.toString());
const backend = computed(() => route.name as 'recognize' | 'facerecognition');

const filteredList = computed(() => {
  if (!list.value || !search.value || !fuse.value) return list.value ?? [];
  return fuse.value.search(search.value).map((r) => r.item);
});

onMounted(() => {
  refresh();
});

async function refresh() {
  try {
    list.value = null;
    const faces = await dav.getFaceList(backend.value);
    list.value = faces.filter((c: IFace) => c.user_id === user.value && String(c.name || c.cluster_id) !== name.value);
    fuse.value = markRaw(new Fuse(list.value, { keys: ['name'] }));
  } catch (e) {
    showError(t('memories', 'Failed to load faces'));
    console.error(e);
  }
}

async function addFace() {
  let name = String();

  try {
    const input = await utils.prompt({
      message: t('memories', 'Create a new face with this name?'),
      title: t('memories', 'Create new face'),
      name: t('memories', 'Name'),
    });

    name = input?.trim() ?? String();
    if (!name) return;

    // Create new directory in WebDAV
    await dav.recognizeCreateFace(user.value, name);

    return selectNew(name);
  } catch (e: any) {
    // Directory already exists
    if (e.status === 405) return selectNew(name);

    showError(t('memories', 'Failed to create face'));
  }
}

function selectNew(faceName: string) {
  emit('select', {
    cluster_id: faceName,
    cluster_type: 'recognize',
    count: 0,
    name: faceName,
    user_id: user.value,
  });
}

function click(item: ICluster) {
  emit('select', item as IFace);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NcTextField), {
        autofocus: true,
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        label: _unref(t)('memories', 'Search'),
        placeholder: _unref(t)('memories', 'Search')
      }, {
        default: _withCtx(() => [
          _createVNode(MagnifyIcon, { size: 16 })
        ]),
        _: 1
      }, 8, ["modelValue", "label", "placeholder"])
    ]),
    (list.value)
      ? (_openBlock(), _createBlock(ClusterGrid, {
          key: 0,
          items: filteredList.value,
          maxSize: 120,
          link: false,
          plus: __props.plus,
          onClick: click,
          onPlus: addFace
        }, null, 8, ["items", "plus"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('memories', 'Loading …')), 1))
  ]))
}
}

})